import LayerGroup from 'ol/layer/Group';
import TileLayer from 'ol/layer/Tile';
import TileWMS from 'ol/source/TileWMS';
import { urlWMSInundaciones, formatoPNG } from './configuracion';

const layer00139 = new TileLayer({
  title: 'Máscara 20130902',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20130902l7etm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00139.setVisible(false);

const layer00138 = new TileLayer({
  title: 'Máscara 20130910',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20130910l8oli202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00138.setVisible(false);

const layer00137 = new TileLayer({
  title: 'Máscara 20131004',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20131004l7etm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00137.setVisible(false);

const layer00136 = new TileLayer({
  title: 'Máscara 20131113',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20131113l8oli202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00136.setVisible(false);
 
const layer00135 = new TileLayer({
  title: 'Máscara 20131129',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20131129l8oli202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00135.setVisible(false);
 
const layer00134 = new TileLayer({
  title: 'Máscara 20131207',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20131207l7etm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00134.setVisible(false);
 
const layer00133 = new TileLayer({
  title: 'Máscara 20131215',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20131215l8oli202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00133.setVisible(false);
  
const layer00132 = new TileLayer({
  title: 'Máscara 20131223',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20131223l7etm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00132.setVisible(false);
  
const layer00131 = new TileLayer({
  title: 'Máscara 20140108',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20140108l7etm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00131.setVisible(false);
  
const layer00130 = new TileLayer({
  title: 'Máscara 20140313',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20140313l7etm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00130.setVisible(false);
  
const layer00129 = new TileLayer({
  title: 'Máscara 20140406',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20140406l8oli202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00129.setVisible(false);
  
const layer00128 = new TileLayer({
  title: 'Máscara 20140430',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20140430l7etm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00128.setVisible(false);
  
const layer00127 = new TileLayer({
  title: 'Máscara 20140508',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20140508l8oli202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00127.setVisible(false);

const layer00126 = new TileLayer({
  title: 'Máscara 20140516',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20140516l7etm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00126.setVisible(false);
  
const layer00125 = new TileLayer({
  title: 'Máscara 20140609',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20140609l8oli202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00125.setVisible(false);
  
const layer00124 = new TileLayer({
  title: 'Máscara 20140711',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20140711l8oli202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00124.setVisible(false);
  
const layer00123 = new TileLayer({
  title: 'Máscara 20140804',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20140804l7etm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00123.setVisible(false);

const layer00122 = new TileLayer({
  title: 'Máscara 20140812',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20140812l8oli202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00122.setVisible(false);
  
const layer00121 = new TileLayer({
  title: 'Máscara 20140820',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20140820l7etm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00121.setVisible(false);

const layer00120 = new TileLayer({
  title: 'Máscara 20140828',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20140828l8oli202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00120.setVisible(false);

export const grupoCapa01_8 = new LayerGroup({
  title: 'Ciclo Hidrológico 2013-2014',
  fold: 'close',
  layers: [layer00120, layer00121, layer00122, layer00123, layer00124, layer00125, layer00126, layer00127, layer00128, layer00129, layer00130, layer00131, layer00132, layer00133, layer00134, layer00135, layer00136, layer00137, layer00138, layer00139]
});